export default __webpack_public_path__ + "static/media/proof-of-humanity.5bb12014.jpg";